import { BucketAggregation as TermAggregationBucket } from "@examspark/types";

type TermAggregation = {
  buckets: TermAggregationBucket[];
  doc_count_error_upper_bound: number;
  sum_other_doc_count: number;
};
type Aggregation = TermAggregation;
type Aggregations = Record<string, Aggregation>;

type FilteredAggregations = Record<string, Record<string, Aggregation>>;

type NestedAggregation = {
  doc_count: number;
  values: {
    doc_count: number;
    values: {
      buckets: TermAggregationBucket[];
    };
  };
};
type NestedAggregations = Record<string, NestedAggregation>;

export const getNestedAggregationBuckets = (
  aggs: NestedAggregations,
  key: string,
) => {
  return aggs[key]?.values.values.buckets ?? [];
};

export const getTermAggregationBucket = (
  aggs: Aggregations,
  key: string,
  bucket: string,
) => {
  return aggs[key]?.buckets.find((b) => b.key === bucket);
};

export const getTermAggregationBucketCount = (
  aggs: Aggregations,
  key: string,
  bucket: string,
) => {
  return getTermAggregationBucket(aggs, key, bucket)?.doc_count;
};

export const getTermAggregationBuckets = (
  aggs: Aggregations | undefined,
  key: string,
) => {
  return aggs?.[key]?.buckets ?? [];
};

export const getFilteredTermAggregationBuckets = (
  aggs: FilteredAggregations | undefined,
  key: string,
) => {
  return aggs?.[key]?.[key]?.buckets ?? [];
};

export const getFilteredNestedTermAggregationBuckets = (
  aggs: FilteredAggregations | undefined,
  key: string,
): TermAggregationBucket[] => {
  const buckets: TermAggregationBucket[] =
    // @ts-expect-error bad param
    aggs?.[key]?.[key]?.[key]?.[key]?.buckets ?? [];

  for (const bucket of buckets) {
    //
    // This is a convention seen in common-app/useSearch
    if (bucket.unique_count != null) {
      bucket.doc_count = bucket.unique_count.doc_count;
    }
  }

  return buckets;
};

export const getTermAggregationBucketKeys = (
  aggs: Aggregations | undefined,
  key: string,
) => {
  return aggs?.[key]?.buckets.map((b) => b.key) ?? [];
};
